// LabelAddPage.js

import React, { useState, useContext, useRef } from 'react';
import Banner from '../../b2b-common/Banner';
import { LoginContext } from '../../../App';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import { saveNewTranslation } from '../../../services/b2b-languages-apiService';
import B2BDialog from '../../b2b-common/B2BDialog';
import { generateTextField } from '../../b2b-common/helpers';

import './LabelAddPage.css';
import { Add } from '@mui/icons-material';
import { ButtonGroup, IconButton, Typography } from '@mui/material';
import { LocaleTabs, TabPanel, TranslationTextField } from '../components/helper';
import LocaleNewDialog from '../components/LocaleNewDialog';

const LabelAddPage = () => {
    const { loginData } = useContext(LoginContext);
    const [sharedKey, setSharedKey] = useState('');
    const [tabValue, setTabValue] = useState(0);
    const emptyTranslations = {
        "sameLabelTranslations": [],
        "allLocales": ["es", "ca", "en"],
    };
    const [translations, setTranslations] = useState(emptyTranslations);
    const [addingNewTranslations, setAddingNewTranslations] = useState(false);
    const [showLocaleRequest, setShowLocaleRequest] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogError, setDialogError] = useState(null);

    const handleAddingNewLocale = async (newLocale) => {
        const newTranslation = {
            "languageId": null,
            "locale": newLocale,
            "key": sharedKey,
            "content": ""
        }
        setTranslations(prevState => ({
            ...prevState,
            sameLabelTranslations: [...prevState.sameLabelTranslations, newTranslation]
        }));
        setShowLocaleRequest(false)
    }

    const handleAddingNewLocaleRequest = () => {
        if (sharedKey && (sharedKey != ''))
            setShowLocaleRequest(true);
        else {
            setDialogError("Please, enter a shared key first.");
            setDialogOpen(true);
        }
    }

    const handleDialogClose = () => {
        setDialogOpen(false);
        setDialogError(null);
    }

    const translationsButtons = [
        <IconButton
            key="new"
            onClick={handleAddingNewLocaleRequest}
            className="translations-management-button"
        >
            <Add />
            <Typography variant="body2">New Locale</Typography>
        </IconButton>,
    ];

    const handleNewTranslations = async () => {
        setAddingNewTranslations(true);
        try {
            for (const translation of translations.sameLabelTranslations)
                await saveNewTranslation(translation, loginData.accessToken);
            console.log('All translations saved successfully.');
            setDialogError(null);
            setDialogOpen(true);
            setTranslations(emptyTranslations);
            setSharedKey('');
        } catch (error) {
            console.error('Error saving translations:', error);
        }
        setAddingNewTranslations(false);
    }

    const buttonsConfig = [
        {
            label: 'Add new translations',
            onClick: handleNewTranslations,
            icon: <Add />,
            disabled: addingNewTranslations,
            isLoading: addingNewTranslations,
            disabledText: 'Adding...'
        },
    ];

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleTranslationChange = (index, newContent) => {
        setTranslations(prevTranslations => {
            const updatedTranslations = [...prevTranslations.sameLabelTranslations];
            updatedTranslations[index] = { ...updatedTranslations[index], content: newContent };
            return { ...prevTranslations, sameLabelTranslations: updatedTranslations };
        });
    };

    const checkConditions = translations && translations.sameLabelTranslations && translations.sameLabelTranslations.length > 0;
    return (
        <div className="labels-new-page">
            <Banner message="Languages Menu: Add a new label" />
            <B2BFormContainer title="New Translations" className="labels-new-form" buttonsConfig={buttonsConfig}>
                {translations && (
                    <>
                        {generateTextField("Key", sharedKey, "label-key-ro-textfield", false, event => setSharedKey(event.target.value))}
                        <ButtonGroup size="small" aria-label="small button group" className="b2b-default-button-group">
                            {translationsButtons}
                        </ButtonGroup>
                        <LocaleTabs
                            value={tabValue}
                            translations={translations}
                            onTabChange={handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="false"
                            aria-label="translation tabs"
                        />
                        {checkConditions && translations.sameLabelTranslations.map((translation, index) => (
                            <TabPanel key={index} value={tabValue} index={index} className='tab-panel-locale-translation'>
                                <TranslationTextField translation={translation}
                                    index={index} onTranslationChange={handleTranslationChange} />
                            </TabPanel>
                        ))}
                    </>
                )}
            </B2BFormContainer>
            <B2BDialog
                open={dialogOpen}
                onClose={handleDialogClose}
                title={dialogError ? 'Error Adding Label' : 'New Label Added'}
            >
                <p>{dialogError || "The new label was added successfully."}</p>
            </B2BDialog>
            {
                showLocaleRequest && <LocaleNewDialog onAddingNewLocale={handleAddingNewLocale} />
            }
        </div>
    )
}

export default LabelAddPage;
